export default function AdminPageLayout({ className = "", children }) {
  return (
    <div
      className={`admin-console admin-page-shell midpoint-app admin-moderation-app admin-data-health-app${
        className ? ` ${className}` : ""
      }`}
    >
      {children}
    </div>
  );
}
